import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllRack() {
    try {
        let res = await client.get("/rack");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchOneRack(id) {
    try {
        let res = await client.get("/rack/rack_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function createRack(name, warehouse_id, capacity, x_location, y_location, rack_type) {
    try {
        let res = await client.post("/rack/create", {
            name: name,
            warehouse_id: warehouse_id,
            capacity: capacity,
            x_location: x_location,
            y_location: y_location,
            rack_type: rack_type,
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function updateRack(id, name, warehouse_id, capacity, x_location, y_location, rack_type) {
    try {
        let res = await client.post("/rack/update", {
            id: id,
            name: name,
            warehouse_id: warehouse_id,
            capacity: capacity,
            x_location: x_location,
            y_location: y_location,
            rack_type: rack_type,
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function deleteRack(id) {
    try {
        let res = await client.delete("/rack/rack_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchAllRack,
    fetchOneRack,
    createRack,
    updateRack,
    deleteRack,
};
